let Slider;
export default () => ({
	product_handles: JSON.parse(localStorage.getItem('theme:recently-viewed-products')),
	products: [],
	location: '',

	getProducts() {
		if (this.product_handles.length > 0) {
			this.product_handles.forEach((handle) => {
				const url = `${window.Shopify.routes.root}products/${handle}?view=get-product-json`;

				fetch(url)
					.then((res) => res.json())
					.then((data) => {
						this.products.push(data);
					})
					.catch((error) => {
						console.log(error);
					});
			});
		} else return;
	},

	getProduct(product) {
		if (product) {
			let current_variant;
			if (product.options[0] === 'Title') {
				current_variant = product.selected_or_first_available_variant;
			} else if (product.variants.length > 0 && product.options[0] === 'Volume') {
				current_variant = product.variants.find((el) => this.getNumberFromString(el.title) > 10);
			} else if (product.variants.length > 0) {
				current_variant = product.variants[0];
			} else {
				current_variant = product.selected_or_first_available_variant;
			}

			return current_variant;
		}
	},

	getDiscount(product) {
		let variant = this.getProduct(product);
		const compare_at_price_at = variant?.compare_at_price_at;
		if (this.location === 'AT' && compare_at_price_at) {
			const formated_compare_at_price_at = Number(compare_at_price_at) * 100;
			const sale = Math.round(
				((formated_compare_at_price_at - price) * 100) / formated_compare_at_price_at,
			);
			return `-${sale} %`;
		} else {
			if (variant.compare_at_price && variant.compare_at_price > variant.price) {
				const sale = Math.round(
					((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price,
				);
				return `-${sale}%`;
			} else {
				return '';
			}
		}
	},

	getPrice(product, compare) {
		let variant = this.getProduct(product);
		if (compare) {
			const comparePrice = Number(variant?.compare_at_price_at);
			if (this.location === 'AT' && comparePrice) {
				return comparePrice.toFixed(2).replace('.', ',');
			} else {
				return (variant.compare_at_price / 100).toFixed(2).replace('.', ',');
			}
		} else {
			return (variant.price / 100).toFixed(2).replace('.', ',');
		}
	},

	getUnitPrice(product) {
		const variant = this.getProduct(product);
		let unit_pice = '';
		const price = variant.unit_price;
		const unit = variant.unit_price_measurement.reference_unit;
		const value = variant.unit_price_measurement.reference_value;
		if (price && unit) {
			unit_pice = `${(price / 100).toFixed(2)} ${window.Shopify.currency.active} / ${value}${unit}`;
		}

		return unit_pice;
	},

	getReviewsLength(product) {
		if (product.reviews_stars_length !== '') {
			return `width: ${product.reviews_stars_length}%;`;
		} else {
			return `width: 0%;`;
		}
	},

	getNumberFromString(string) {
		const formated_string = string.match(/\d+/);
		if (formated_string) {
			const nums = Number(formated_string[0]);
			if (nums) {
				return nums;
			}
		} else return '';
	},

	fixHeight() {
		this.$el.style.height = `${this.$el.clientHeight}px`;
		this.$el.classList.add('active');
	},
	unfixHeight() {
		this.$el.style.height = `${this.$el.clientHeight}px`;
		this.$el.classList.remove('active');
	},

	async addCartForProductCard(product) {
		const quantity = this.$el.previousElementSibling.value;
		let variant = this.getProduct(product);
		const productData = {
			id: variant.id,
			quantity: Number(quantity),
			sections: 'cart-main,header',
		};
		const response = await fetch(window.routes.cartAdd + '.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify(productData),
		});
		const data = await response.json();
		if (response.ok) {
			const destinationCartPopup = document.getElementById('cart-popup');
			const sourceCartPopup = new DOMParser()
				.parseFromString(data.sections['header'], 'text/html')
				.getElementById('cart-popup');
			if (destinationCartPopup && sourceCartPopup) {
				destinationCartPopup.innerHTML = sourceCartPopup.innerHTML;
			}
			this.$dispatch('cart-update');
		}

		this.gtmAddToCart(product, variant, quantity);
	},

	createSlider() {
		Slider = new window.Swiper('.related-products__products', {
			slidesPerView: 1.25,
			speed: 500,
			spaceBetween: 10,
			breakpoints: {
				480: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 3,
				},
				1024: {
					slidesPerView: 4,
				},
				1440: {
					slidesPerView: 5,
				},
			},
			navigation: {
				nextEl: '.next-slide',
				prevEl: '.prev-slide',
			},
			pagination: {
				el: '.related-products__pagination',
				type: 'progressbar',
			},
		});
	},

	gtmAddToCart(product, variant, item_quantity) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'EEC-AddToCart',
			value: variant.price,
			ecommerce: {
				currencyCode: window.Shopify.currency.active,
				add: {
					products: [
						{
							id: variant.sku,
							sku: variant.sku,
							name: product.title,
							price: (variant.price / 100).toFixed(2),
							brand: 'Brooklyn Soap Company',
							category: product.main_category,
							quantity: Number(item_quantity),
						},
					],
				},
			},
			items: [{ id: variant.sku, google_business_vertical: 'retail' }],
		});

		setTimeout(function () {
			// Clear the ecommerce data for subsequent hits.
			window.dataLayer.push({ ecommerce: null });
		}, 3);
	},

	init() {
		this.getProducts();
		this.$watch('products', () => {
			setTimeout(() => {
				this.createSlider();
			}, 250);
		});
	},
});
